import { Lock } from "lucide-react";
import { ERP_PROVIDER_LABELS, type ERPProviderKey } from "@forgepoint/shared";
import { Badge } from "@/components/ui/badge";

interface LockedSettingBadgeProps {
  providers: ERPProviderKey[];
}

/**
 * Lock badge naming the ERPs that force a setting, e.g. "Required by Prophet 21 and JobBOSS²".
 * @param props - LockedSettingBadgeProps
 * @returns Locked setting badge element
 */
export function LockedSettingBadge({ providers }: LockedSettingBadgeProps) {
  const labels = providers.map((provider) => ERP_PROVIDER_LABELS[provider]);
  return (
    <Badge
      variant="secondary"
      className="gap-1 text-xs font-normal text-muted-foreground"
    >
      <Lock className="h-3 w-3 shrink-0" aria-hidden />
      Required by {joinWithAnd(labels)}
    </Badge>
  );
}

/**
 * Joins labels into a readable list, e.g. "A, B and C".
 * @param labels - The labels to join
 * @returns The joined list
 */
function joinWithAnd(labels: string[]): string {
  if (labels.length <= 1) {
    return labels.join("");
  }
  return `${labels.slice(0, -1).join(", ")} and ${labels[labels.length - 1]}`;
}
